import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { GalleryDto } from '@picflow/types';
import { ColorPickerComponent } from '../../../color-picker/color-picker.component';
import { GROWTHBOOK } from '../../../growthbook';
import {
  GalleryEmbedOptions,
  GalleryEmbedService,
  NewGalleryEmbedOptions,
} from '../../../services/gallery-embed.service';
import { PermissionService } from '../../../services/permission.service';
import { ToastService } from '../../../services/toast.service';
import { ProTagComponent } from '../../../shared-extra/components/pro-tag/pro-tag.component';
import { ShareDirective } from '../../../shared-extra/directives/share.directive';
import { PermissionsPipe } from '../../../shared-extra/pipes/permissions.pipe';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TransitionPreventorDirective } from '../../../shared/directives/transition-preventor.directive';

@Component({
  selector: 'app-share-gallery-embed',
  templateUrl: './share-gallery-embed.component.html',
  styleUrls: ['./share-gallery-embed.component.scss'],
  standalone: true,
  imports: [
    SvgComponent,
    ButtonDirective,
    RouterLink,
    ContextMenuComponent,
    TransitionPreventorDirective,
    FormsModule,
    ShareDirective,
    PermissionsPipe,
    ColorPickerComponent,
    ProTagComponent,
  ],
})
export class ShareGalleryEmbedComponent implements OnInit {
  @Input() gallery: GalleryDto;
  @Output() onChangeMode = new EventEmitter();
  embedCode = '';
  options: GalleryEmbedOptions;
  newOptions: NewGalleryEmbedOptions;

  public growthBook = inject(GROWTHBOOK);

  constructor(
    private toasts: ToastService,
    private galleryEmbedService: GalleryEmbedService,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.newOptions = this.galleryEmbedService.getNewEmbedPreferences();
    this.calculateEmbedCode();
  }

  async calculateEmbedCode() {
    this.embedCode = this.galleryEmbedService.getNewEmbedCode(this.gallery, this.newOptions);
    if (!this.permissionService.canDisplayElement('gallery.embed-gallery', this.gallery)) {
      this.embedCode = this.embedCode.substring(0, 395) + '...';
    }
  }

  onEmbedChange() {
    this.calculateEmbedCode();
    this.galleryEmbedService.setNewEmbedPreferences(this.newOptions);
  }

  onCopy() {
    this.toasts.add('Embed code copied!', 'success');
  }
}
